import styled from 'styled-components';
import ArrowIcon from "../../../assests/images/arrow-down.svg";


export const FilterSection = styled.div`
    display: flex;
    position: relative;
     @media screen and (max-width:991px){
             width:100%; 
          }
    .dropdown{
          @media screen and (max-width:575px){ 
             width:100%;
          }
    }
    
    .dropdown-toggle { 
        background-color: #F9DC70 !important; 
        border: none !important;
        border-radius: 10px !important;
        color: #333333 !important;
        font-size: 18px !important;
        padding: 11px 55px 11px 24px !important;
        font-family: "Jost", sans-serif !important;
        font-weight:400 !important;
         width:100%;
             transition: all 0.5s;
        &:after{
          position: absolute;
            content: " ";
            border-right: 1px solid rgb(0, 0, 0);
            border-top: 1px solid rgb(0, 0, 0);
            width: 12px;
            height: 12px;
            transform: rotate(138deg);
            cursor: pointer;
            display: block;
            right: 23px;
            top: 14px;
            margin: 0px !important;
            border-left: 0;
                transition: all 0.5s;
        }
        &:active{
            background: #F9DC70 !important;
            color: #333333 !important;
        }
        &.show {
        
            &:after{
          transform: rotate(-45deg);
         top: 21px;

            }
        }
        
    }
    .dropdown-menu.show{
        background: #fff !important;
        box-shadow: 0px 10px 30px #00000033 !important;
        border-radius: 20px !important;
        border: none !important;
        max-width: 320px !important;
        padding:23px 60px 20px 23px;
        overflow: scroll;
    max-height: 250px;
       z-index: 1;
        // inset: 0px 0 auto -118px !important;
        // transform: translate(-121px, 50px) !important;

        // @media screen and (max-width:1440px) {
        //     transform: translate(0, 50px) !important;
        // }

        @media screen and (max-width: 575px){
            padding: 15px;
            border-radius: 15px !important;
        }
        @media screen and (max-width: 480px){
            min-width: 280px !important;
        }
    }
    .dropdown-item {
        color: #000000;
        font-size: 16px;
        font-family: "Jost", sans-serif;
        font-weight:500;
        padding: 0 0 3px 0;

        &:hover ,&:active{
            background: #FFFFFF;
               color: #000000 !important;
        } 
        
        &:hover{
            background-color: transparent;
        }
    }
`;